// ===========================================================================
// PROJECTS CONFIGURATION - Single Source of Truth
// ===========================================================================
// To add a new presale, simply add a new entry to PROJECTS_CONFIG below.
// All other files will automatically pick up the changes
const PROJECTS_CONFIG = {
  PRC: {
    preSale: "0xA2B4b493ac1BE5c34f6d482D4816615dA711B902",
    claim: "0x35958203b07414166dC0637F3bDd1FC2A0f00a54",
    graph: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/xen-graph/0.0.1/gn",
    label: "$PRICE",
    imageSrc: "/assets/price.png",
  },
  // XPROTOCOL: {
  //   preSale: "0x1b15636db18fE1AA0b3A91F5fFEAF92a5EaFAcf6",
  //   claim: "0xe18D0f09324766ac456f635A947EC2a3466F51A5",
  //   graph: "https://api.studio.thegraph.com/query/112168/x-protocol/version/latest",
  //   label: "Xprotocol",
  //   imageSrc: "	https://gems.vip/assets/alldetailpages/xprotocol/main-img.png",
  // },
  // TIGA: {
  //   preSale: "0x9b35F4bf2DFC85f2e1eF9C0bAA5a37066832EaaA",
  //   claim: "0xeaa9FB8cb2AEB5e6923c0439FAa3CfE2f159556a",
  //   graph: "https://api.studio.thegraph.com/query/1721837/tiga-presale/version/latest",
  //   label: "Tiga",
  //   imageSrc: "https://gems.vip/assets/alldetailpages/tiga/main-img.png",
  // },

  // CHAINERS: {
  //   preSale: "0x84F44f2FDC9C2e2d78Fae77d2201F74b88a1bAd9",
  //   claim: "0x9861F09a319d098E8Ce0056cf92Fcc6ca96a0285",
  //   graph: "https://api.studio.thegraph.com/query/112168/chainersgraph/version/latest",
  //   label: "Chainers",
  //   imageSrc: "https://gems.vip/assets/alldetailpages/chainers/main-img.png",
  // },
 
  // SCREX: {
  //   preSale: "0x7D765A830e4f23843C0d78FACC7C1069BA197546",
  //   claim: "0x3233B1188D9082A177e9F14295D8Ddb9c9157249",
  //   graph: "https://api.studio.thegraph.com/query/112168/screxgraph-4/version/latest",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   institutionGraph: "https://api.studio.thegraph.com/query/112168/screxgraph-4/version/latest",
  //   label: "Screx",
  //   imageSrc: "https://gems.vip/assets/alldetailpages/screx/screxlogo.svg",
  // },

  // LUCKIFY: {
  //   preSale: "0x90E5B93eE48105D131aeA7CF8f295879Ab4edE53",
  //   claim: "0x2CFfc9dA6528abFa34ac80e1F0E16A473dc298bf",
  //   graph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokensOnly-graph/api",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   institutionGraph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokensOnly-graph/api",
  //   label: "Luckify",
  //   imageSrc: "/assets/luckify.svg",
  // },

  // MATCHAIN: {
  //   preSale: "0xc36f3CBc4e29E3E54834E6e853163B05A9Eb2a6A",
  //   claim: "0xDa5dbE6506990EF7EC90E435F9CDC7A025b9BC3B",
  //   graph: "https://api.studio.thegraph.com/query/63987/matchain-staging/version/latest",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
  //   label: "Matchain",
  //   imageSrc: "/assets/matchain.svg",
  // },

  // RAIN: {
  //   preSale: "0x81cdF76D3D932611566bF957e521698CC6B3f606",
  //   preSaleV2: "0xc80BDe419544b7481D5bD6665803B1C97557C046",
  //   preSaleV3: "0xEE285Ae618cf2e22C71D4BE82Ab0D6ab70A1FBBF",
  //   claim: "0xFF3e0397CB96DA223D14b4FC9DCd1361Beb99FD7",
  //   claimV2: "0x1fD57d52f110B3A3EF55de122d8eCcc1986Feea6",
  //   claimV3: "0x1f7f01cf788B60ddA3506711FB615659de169515",
  //   institutionPreSale: "0x284f7Ad1F3c6Fb687e76d9D6E06EC0bBF3B38C37",
  //   graph: "https://api.studio.thegraph.com/query/63987/rain-presale-staging/version/latest",
  //   graphV2: "https://api.studio.thegraph.com/query/75549/rain-presale-insurance-graph/version/latest",
  //   graphV3: "https://api.studio.thegraph.com/query/63987/rain-subscription-lockup/version/latest",
  //   institutionGraph: "https://api.studio.thegraph.com/query/75549/presale-institution-graph/version/latest",
  //   label: "Rain",
  //   imageSrc: "/assets/rain.svg",
  //   useSpecialContract: true, // Flag for custom contract handling
  // },

  // ASTRANOVA: {
  //   preSale: "0x4e9FD4bB3eAe2b909713B57644B814AA4a531cd3",
  //   preSaleV2: "0x5ac9755f906ca17EEBA8833A8D1d43fC3c2c000B",
  //   claim: "0xBCf3E7379A05Bdabd76F4AfD7f752BEd71765EE9",
  //   claimV2: "0xb403876ce7DEEfe827F6Dff03Fa672Fe60cC915D",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   graph: "https://api.studio.thegraph.com/query/75549/astro-nova-subscription-lockup-graph/version/latest",
  //   graphV2: "https://api.studio.thegraph.com/query/75549/sale-graph-v1/version/latest",
  //   institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
  //   label: "Astra Nova",
  //   imageSrc: "/assets/astronova.svg",
  //   useSpecialContract: true, // Flag for custom contract handling
  // },

  // NFA: {
  //   preSale: "0x8246b57D50A25B48E0045f7c370b131c75bEbFBD",
  //   claim: "0x55c581B29739e43d357e2b083F6839BdBb784Bc8",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   graph: "https://api.studio.thegraph.com/query/63987/nfa-graph/version/latest",
  //   institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
  //   label: "NFA",
  //   imageSrc: "/assets/nfa.svg",
  // },

  // LEIA: {
  //   preSale: "0x5e1EDf353122f06347BB5834ac50D25545EfB718",
  //   claim: "0x87e1F8AD083dE8e6AC88D28Bf4C28EF0aaD661D6",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   graph: "https://api.studio.thegraph.com/query/75549/leia-graph/v0.0.7",
  //   institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
  //   label: "Leia",
  //   imageSrc: "/assets/leia.svg",
  //   useSpecialContract: true, // Flag for custom contract handling
  // },

  // OLYMPUS: {
  //   preSale: "0x7C94504340683d339268BD4ac8B1FBD8Bf73Ac97",
  //   claim: "0x1a006eA738aB36e6d25C2DD19e14f23a9F2CC7cC",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   graph: "https://api.studio.thegraph.com/query/75549/leia-graph/v2.2.3",
  //   institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
  //   label: "Olypmus",
  //   imageSrc: "/assets/olympus.svg",
  //   useSpecialContract: true, // Flag for custom contract handling
  // },

  // INCENTIV: {
  //   preSale: "0x4951aDB0D0Fd1f04bCEc0AD7EA727712314EBd9B",
  //   claim: "0x2baB468eD1f6bbF95068A3A4F8669aFC580e2052",
  //   graph: "https://api.studio.thegraph.com/query/63987/matchain-staging/version/latest",
  //   institutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
  //   institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",
  //   label: "Incentiv",
  //   imageSrc: "/assets/incentiv-new-logo.svg",
  //   useSpecialContract: true, // Flag for custom contract handling
  // },

  // GEMS: {
  //   preSale: "0xA242cd6408641e16A51E91D565aE204eBe273F34",
  //   claim: "0x473F7c7757dd866520B8422de18635981701670e",
  //   graph: "https://api.studio.thegraph.com/query/63987/gems-presale-main/latest1",
  //   label: "Gems",
  //   imageSrc: "/assets/gems.svg",
  // },

  // NODEMINER: {
  //   claim: "0x20Fa1ad4021d1B7373b72De6D77468A7c19C5F22",
  //   graph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/miner-node-staging/api",
  //   label: "Node Miner",
  //   imageSrc: "/assets/nodeminer.svg", // Add your image path
  //   hasPreSale: false, // Flag to indicate no presale contract
  // },
};


// ============================================================================
// LEGACY EXPORTS - For backward compatibility with existing code
// ============================================================================
// This section auto-generates the old flat structure from PROJECTS_CONFIG
// so existing code doesn't break

const legacyExports = Object.entries(PROJECTS_CONFIG).reduce((acc, [key, config]) => {
  // Main contracts
  if (config.preSale) acc[`${key}PreSale`] = config.preSale;
  if (config.claim) acc[`${key}Claim`] = config.claim;
  if (config.graph) acc[`${key}Graph`] = config.graph;

  // Version 2
  if (config.preSaleV2) acc[`${key}PreSaleV2`] = config.preSaleV2;
  if (config.claimV2) acc[`${key}ClaimV2`] = config.claimV2;
  if (config.graphV2) acc[`${key}GraphV2`] = config.graphV2;

  // Version 3
  if (config.preSaleV3) acc[`${key}PreSaleV3`] = config.preSaleV3;
  if (config.claimV3) acc[`${key}ClaimV3`] = config.claimV3;
  if (config.graphV3) acc[`${key}GraphV3`] = config.graphV3;

  // Institution contracts
  if (config.institutionPreSale) acc[`${key}InstitutionPreSale`] = config.institutionPreSale;
  if (config.institutionGraph) acc[`${key}institutionGraph`] = config.institutionGraph;

  return acc;
}, {});
// Environment?.PROJECTS[project?.privateSale]?.imageSrc
// console.log(legacyExports, 'legacyExports');

// ============================================================================
// MAIN ENVIRONMENT OBJECT
// ============================================================================

const Environment = {
  // Projects Configuration (New Way)
  PROJECTS: PROJECTS_CONFIG,

  // Legacy flat exports (Old Way - for backward compatibility)
  ...legacyExports,

  // Shared Institution Graph
  institutionGraph: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

  // Additional addresses
  NodeMinerTokenRegistry: "0x07AA440a2cc116fB1C01BF135F6d7AFBdd36c57f",

  // Token addresses
  eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
  busd: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9", // USDT
  usdc: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",

  tomi: "0x84f0bC91f23649c76139d402a1c00c6aC19A4400",
  wbtc: "0x54410d42628C7fD6720C489219033345Bcb7Cc73",
  pepe: "0x0592EBa69Aa5f2eF68d9cb740fBaB2c0c0CC6A91",
  link: "0x37bBd68526C9BDb49f18fB36983701E344f2A163",
  uni: "0x079c46A5Ba477400a326E03Ad8D22FaBeaE57b4F",
  dop: "0xa048E46C35cf210bB0d5bb46b2DD06828Ef17893",
  gems: "0x7ddd14e3a173a5db7bb8fd74b82b667f221492b9",
};

export default Environment;

// let Environment = {
//   PreSale: "0x4951aDB0D0Fd1f04bCEc0AD7EA727712314EBd9B",
//   Claim: "0x2baB468eD1f6bbF95068A3A4F8669aFC580e2052",
//   Graph: "https://api.studio.thegraph.com/query/63987/matchain-staging/version/latest",
//   // PreSale: "0x8917FE03096Ce297064DB58e85faEEaBF8472BDC",
//   // Claim: "0xc625f377245713DAa97f6dcb865f6206C6c3F664",
//   // InstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   // Graph: "https://api.studio.thegraph.com/query/63987/abc-test/v-01",
//   institutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",


//   MATCHAINPreSale: "0xc36f3CBc4e29E3E54834E6e853163B05A9Eb2a6A",
//   MATCHAINClaim: "0xDa5dbE6506990EF7EC90E435F9CDC7A025b9BC3B",
//   MATCHAINGraph: "https://api.studio.thegraph.com/query/63987/matchain-staging/version/latest",
//   MATCHAINInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   MATCHAINinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",



//   LUCKIFYPreSale: "0x90E5B93eE48105D131aeA7CF8f295879Ab4edE53",
//   LUCKIFYClaim: "0x2CFfc9dA6528abFa34ac80e1F0E16A473dc298bf",
//   LUCKIFYGraph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokensOnly-graph/api",
//   LUCKIFYInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   LUCKIFYinstitutionGraph:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokensOnly-graph/api",



//   SCREXPreSale: "0x7D765A830e4f23843C0d78FACC7C1069BA197546",
//   SCREXClaim: "0x3233B1188D9082A177e9F14295D8Ddb9c9157249",
//   SCREXGraph: "https://api.studio.thegraph.com/query/112168/screxgraph-4/version/latest",
//   SCREXInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   SCREXinstitutionGraph:
//     "https://api.studio.thegraph.com/query/112168/screxgraph-4/version/latest",


//   CHAINERSPreSale: "0x84F44f2FDC9C2e2d78Fae77d2201F74b88a1bAd9",
//   CHAINERSClaim: "0x9861F09a319d098E8Ce0056cf92Fcc6ca96a0285",
//   CHAINERSGraph: "https://api.studio.thegraph.com/query/112168/chainersgraph/version/latest",


//   TIGAPreSale: "0xF1e7EAE80C56e3627e68130c0a3724fB3c76dcdf",
//   TIGAClaim: "0x3C0BD763813BE15e2D97C89F6dDd892537d12d5a",
//   TIGAGraph: "https://api.studio.thegraph.com/query/112168/tigagraph/version/latest",
//   ///////// LEIA

//   LEIAPreSale: "0x5e1EDf353122f06347BB5834ac50D25545EfB718",
//   LEIAClaim: "0x87e1F8AD083dE8e6AC88D28Bf4C28EF0aaD661D6",
//   LEIAInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   LEIAGraph: "https://api.studio.thegraph.com/query/75549/leia-graph/v0.0.7",
//   LEIAinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// OLYMPUS

//   OlympusPreSale: "0x7C94504340683d339268BD4ac8B1FBD8Bf73Ac97",
//   OlympusClaim: "0x1a006eA738aB36e6d25C2DD19e14f23a9F2CC7cC",
//   OlympusInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   OlympusGraph: "https://api.studio.thegraph.com/query/75549/leia-graph/v2.2.3",
//   OlympusinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// NFA

//   NFAPreSale: "0x8246b57D50A25B48E0045f7c370b131c75bEbFBD",
//   NFAClaim: "0x55c581B29739e43d357e2b083F6839BdBb784Bc8",
//   NFAInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   NFAGraph:
//     "https://api.studio.thegraph.com/query/63987/nfa-graph/version/latest",
//   NFAinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// ASTRO NOVA

//   AstroNovaPreSale: "0x4e9FD4bB3eAe2b909713B57644B814AA4a531cd3",
//   AstroNovaPreSaleV2: "0x5ac9755f906ca17EEBA8833A8D1d43fC3c2c000B",

//   AstroNovaClaim: "0xBCf3E7379A05Bdabd76F4AfD7f752BEd71765EE9",
//   AstroNovaClaimV2: "0xb403876ce7DEEfe827F6Dff03Fa672Fe60cC915D",

//   AstroNovaInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   AstroNovaGraph:
//     "https://api.studio.thegraph.com/query/75549/astro-nova-subscription-lockup-graph/version/latest",

//   AstroNovaGraphV2:
//     "https://api.studio.thegraph.com/query/75549/sale-graph-v1/version/latest",

//   AstroNovainstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",

//   ///////// RAIN

//   RainPreSale: "0x81cdF76D3D932611566bF957e521698CC6B3f606",
//   RainPreSaleV2: "0xc80BDe419544b7481D5bD6665803B1C97557C046",
//   RainPreSaleV3: "0xEE285Ae618cf2e22C71D4BE82Ab0D6ab70A1FBBF",

//   RainClaim: "0xFF3e0397CB96DA223D14b4FC9DCd1361Beb99FD7",
//   RainClaimV2: "0x1fD57d52f110B3A3EF55de122d8eCcc1986Feea6",
//   RainClaimV3: "0x1f7f01cf788B60ddA3506711FB615659de169515",

//   RainInstitutionPreSale: "0x284f7Ad1F3c6Fb687e76d9D6E06EC0bBF3B38C37", // cahnge by jawad
//   RainGraph:
//     "https://api.studio.thegraph.com/query/63987/rain-presale-staging/version/latest",

//   RainGraphV2:
//     "https://api.studio.thegraph.com/query/75549/rain-presale-insurance-graph/version/latest",
//   RainGraphV3:
//     "https://api.studio.thegraph.com/query/63987/rain-subscription-lockup/version/latest",

//   RaininstitutionGraph:
//     "https://api.studio.thegraph.com/query/75549/presale-institution-graph/version/latest",

//   ///////// MINERS CLAIMS
//   MinersClaim: "0x20Fa1ad4021d1B7373b72De6D77468A7c19C5F22",
//   MinersGraph:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/miner-node-staging/api",

//   /////// GEMS TESTNET

//   GemsGraph:
//     "https://api.studio.thegraph.com/query/63987/gems-presale-main/latest1", //TESTNET
//   GemsClaim: "0x473F7c7757dd866520B8422de18635981701670e", //TESTNET
//   GemsPreSale: "0xA242cd6408641e16A51E91D565aE204eBe273F34", //TESTNET

//   NodeMinerTokenRegistry: "0x07AA440a2cc116fB1C01BF135F6d7AFBdd36c57f", //TESTNET

//   busd: "0x6fEA2f1b82aFC40030520a6C49B0d3b652A65915",
//   tomi: "0x84f0bC91f23649c76139d402a1c00c6aC19A4400",
//   eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
//   wbtc: "0x54410d42628C7fD6720C489219033345Bcb7Cc73",
//   usdc: "0x25762231808F040410586504fDF08Df259A2163c",
//   pepe: "0x0592EBa69Aa5f2eF68d9cb740fBaB2c0c0CC6A91",
//   link: "0x37bBd68526C9BDb49f18fB36983701E344f2A163",
//   uni: "0x079c46A5Ba477400a326E03Ad8D22FaBeaE57b4F",
//   dop: "0xa048E46C35cf210bB0d5bb46b2DD06828Ef17893",
//   gems: "0x7ddd14e3a173a5db7bb8fd74b82b667f221492b9",
// };
// export default Environment;